import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'
import { validateQueryStringParameters } from '../../helpers/api'

const requestApi = tokenSlice.injectEndpoints({
  reducerPath: 'requestApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Request'],
  endpoints(builder) {
    return {
      // GET
      getRequestByType: builder.query({
        query: (businessUnitId) => ({
          url: `Request/Type/${businessUnitId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getRequestCategory: builder.query({
        query: (args) => {
          const { businessUnitId, keyCode } = args;
          return {
            url: `Request/CategoryList?businessUnitId=${businessUnitId}&keyCode=${keyCode}`,
          };
        },
        providesTags: ["Request"],
      }),

      getRequestByMainApprovalInfo: builder.query({
        query: (requestMainId) => ({
          url: `Request/MainApprovalInfo/${requestMainId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),
      getRequestByDetailApprovalInfo: builder.query({
        query: (requestDetailId) => ({
          url: `Request/DetailApprovalInfo/${requestDetailId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getRequestByFollowUser: builder.query({
        query: (requestMainId) => ({
          url: `Request/FollowUser/${requestMainId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getRequestByInfo: builder.query({
        query: (params) => ({
          url: `Request/Info`,
          method: 'GET',
          params: validateQueryStringParameters(params),
        }),

        providesTags: ['Request'],
      }),

      // POST
      postRequestWaitingForApproval: builder.mutation({
        query: (data) => ({
          url: 'Request/WaitingForApproval',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestAll: builder.mutation({
        query: (data) => ({
          url: 'Request/All',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestHeld: builder.mutation({
        query: (data) => ({
          url: 'Request/Held',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestChangeApproval: builder.mutation({
        query: (data) => ({
          url: 'Request/ChangeApproval',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestDraft: builder.mutation({
        query: (data) => ({
          url: 'Request/Draft',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestBuyersAssignment: builder.mutation({
        query: (data) => ({
          url: 'Request/BuyersAssignment',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestSave: builder.mutation({
        query: (data) => ({
          url: 'Request/Save',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestSendToApprove: builder.mutation({
        query: (data) => ({
          url: `Request/SendToApprove`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestChangeMainStatus: builder.mutation({
        query: (data) => ({
          url: 'Request/ChangeMainStatus',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestChangeDetailStatus: builder.mutation({
        query: (data) => ({
          url: 'Request/ChangeDetailStatus',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestUpdateBuyer: builder.mutation({
        query: (data) => ({
          url: 'Request/UpdateBuyer',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      postRequestCreateFollowUser: builder.mutation({
        query: (data) => ({
          url: 'Request/CreateFollowUser',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      // DELETE
      deleteRequest: builder.mutation({
        query: (data) => ({
          url: `Request/Delete`,
          method: 'DELETE',
          body: data,
        }),
        invalidatesTags: ['Request'],
      }),

      deleteFollowUserRequest: builder.mutation({
        query: (requestFollowId) => ({
          url: `Request/DeleteFollowUser/${requestFollowId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Request'],
      }),

      rejectReasons: builder.query({
        query: () => ({
          url: 'General/RejectReasons',
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      businessCategories: builder.query({
        query: () => ({
          url: 'General/BusinessCategories',
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getUomandRuom: builder.query({
        query: (businessUnitId) => ({
          url: `UOM/${businessUnitId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getLocation: builder.query({
        query: (businessUnitId) => ({
          url: `Location/GetLocationList/${businessUnitId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getAccountCodes: builder.query({
        query: (businessUnitId) => ({
          url: `AccountCode/GetAccountCodes/${businessUnitId}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getItemCodeInfoByItemCode: builder.query({
        query: (params) => {
          return {
            url: `Item/GetItemCodeInfoByItemCode`,
            params: validateQueryStringParameters(params),
          }
        },

        providesTags: ['Request'],
      }),

      getRequestAttachments: builder.query({
        query: (params) => {
          return {
            url: `Attachment/GetRequestAttachments`,
            params: validateQueryStringParameters(params),
          }
        },

        providesTags: ['Request'],
      }),

      getDetailApprovalInfo: builder.query({
        query: (id) => ({
          url: `Request/DetailApprovalInfo/${id}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      getMainApprovalInfo: builder.query({
        query: (id) => ({
          url: `Request/MainApprovalInfo/${id}`,
          method: 'GET',
        }),
        providesTags: ['Request'],
      }),

      postRequestRetrieve: builder.mutation({
        query: (data) => {
          return {
            url: `Request/Retrieve`,
            method: 'POST',
            body: data,
          }
        },

        providesTags: ['Request'],
      }),
    }
  },
})

export const {
  useGetDetailApprovalInfoQuery,
  useGetMainApprovalInfoQuery,
  useGetRequestByTypeQuery,
  useGetRequestCategoryQuery,
  useGetRequestByMainApprovalInfoQuery,
  useGetRequestByDetailApprovalInfoQuery,
  useGetRequestByFollowUserQuery,
  useGetRequestByInfoQuery,
  usePostRequestWaitingForApprovalMutation,
  usePostRequestAllMutation,
  usePostRequestHeldMutation,
  usePostRequestChangeApprovalMutation,
  usePostRequestDraftMutation,
  usePostRequestSaveMutation,
  usePostRequestSendToApproveMutation,
  usePostRequestChangeMainStatusMutation,
  usePostRequestChangeDetailStatusMutation,
  usePostRequestUpdateBuyerMutation,
  usePostRequestCreateFollowUserMutation,
  useDeleteRequestMutation,
  useDeleteFollowUserRequestMutation,
  useRejectReasonsQuery,
  useBusinessCategoriesQuery,
  useGetUomandRuomQuery,
  useGetLocationQuery,
  useGetAccountCodesQuery,
  useGetItemCodeInfoByItemCodeQuery,
  useGetRequestAttachmentsQuery,
  usePostRequestBuyersAssignmentMutation,
  usePostRequestRetrieveMutation
} = requestApi
export { requestApi }